import React, { useEffect, useState } from "react";
import * as S from '../../styled'
import moment from 'moment';
import intl from 'react-intl-universal';
import ButtonEditDateTimeDoor from "../buttonEditDateTimeDoor";
import { useLoadCompositionBuildingContext } from "../../../../context/load-composition-building-context";
import ModalAddNotes from "../modalAddNotes";
import editIcon from 'images/edit.svg';
import { isScheduleAgreementFlow } from "utils/validations-general-settings";
import PropTypes from 'prop-types';
import { RoundButton } from "components/round-button";
import Button from "components/button";

const DestinationBooking = ({ isValidDay, queryParams }) => {
  const [oldParams, setOldParams] = useState({
    dia: null,
    hora: null,
    destinoId: null,
    destinoName: null,
    door: null
  });
  const {
    isEditDateMode,
    setIsEditDateMode,
    params,
    breweryNote,
    isEmergencyNegotiation
  } = useLoadCompositionBuildingContext();
  const [showAddNoteModal, setShowAddNoteModal] = useState(false);
  const [notes, setNotes] = useState();

  useEffect(() => {
    if (breweryNote !== notes) {
      setNotes(breweryNote);
    }
  }, [breweryNote]);

  const handleEditDate = () => {
    setOldParams({
      ...params,
      door: doorDescription
    });
    setIsEditDateMode(true);
  }

  const doorDescription = queryParams.get('doorDescription');
  const isNewSlotSelected =
    oldParams.dia !== params.dia ||
    oldParams.hora !== params.hora ||
    oldParams.door != queryParams.get('doorDescription');
  const disabled = !(isValidDay && isNewSlotSelected);

  const formatDestiny = (destiny) => {
    if (destiny !== undefined){
      const splitedString = destiny.split("-");
      const destinyDescription = isScheduleAgreementFlow() 
        ? splitedString[1]?.replace(/([A-Z])/g, ' $1') 
        : splitedString[1];
      return `${splitedString[0]} - ${destinyDescription}`;
    }
  }

  return (
    <React.Fragment>
      <S.InfosWrapper isLast={!breweryNote} isCentered>
        <div className="destiny-door-content">
          <div className="destiny-content">
            <span className="title">{intl.get("commons.destiny")}</span>
            <span className="description" data-testid={`load-composition-destination`}>{formatDestiny(params.destinoName)}</span>
          </div>
          <div className="door-content">
            <span className="title">{intl.get("commons.door")}</span>
            {isEmergencyNegotiation ?
              <span className="description">{doorDescription ?? "-"}</span>
              :
              <S.ButtonDescription className="description-door" data-testid={`load-composition-door`} onClick={handleEditDate}>{doorDescription ?? "-"}</S.ButtonDescription>              
            }
          </div>
        </div>
        <div className="content-date-time">
          <div>
            <span className="title">
              {intl.get("loadComposition.building.deliveryDateAndTime")}
            </span>
            {isValidDay ? (
              <S.ButtonDescription className="description-date-time" data-testid={`load-composition-date-time`} onClick={handleEditDate}>
                {moment(params.dia).format("[DM]")}
                {` ${intl.get("commons.at")} `}
                {moment(params.hora, "HH:mm:ss").format("LT")}
              </S.ButtonDescription>
            ) : (
              <span className="description">-</span>
            )}
          </div>
          <ButtonEditDateTimeDoor
            disabled={disabled}
            oldParams={oldParams}
            setOldParams={setOldParams}
            queryParams={queryParams}
          />
          {!isEditDateMode && !breweryNote && (
            <Button
              onClick={() => setShowAddNoteModal(true)}
              buttonType="default"
              value={intl.get("loadComposition.breweryNotes.addNotes")}
              className="add-notes"
            />
          )}
        </div>
      </S.InfosWrapper>

      {breweryNote && (
        <S.InfosWrapper isLast>
          <div className="attached-notes">
            <span className="title">
              {intl.get("loadComposition.breweryNotes.attachedNotes")}
              <RoundButton
                id="edit"
                aria-label="Edit"
                title={intl.get("geral.buttonsDefault.edit")}
                iconHeight="16px"
                onClick={() => setShowAddNoteModal(true)}
              >
                <img
                  className="btn-edit"
                  src={editIcon}
                  style={{ width: '14px', height: '14px', padding: '0px 4px' }}
                  alt="edit-icon"
                />
              </RoundButton>
            </span>
            <S.DescriptionNotes className="description-notes" onClick={() => setShowAddNoteModal(true)}>{breweryNote}</S.DescriptionNotes>
          </div>
        </S.InfosWrapper>
      )}

      <ModalAddNotes
        notes={notes}
        setNotes={setNotes}
        showAddNoteModal={showAddNoteModal}
        setShowAddNoteModal={setShowAddNoteModal}
      />
    </React.Fragment>
  );
}

DestinationBooking.propTypes = {
  isValidDay: PropTypes.bool.isRequired, 
  queryParams: PropTypes.object.isRequired
}

export default DestinationBooking;
